module.exports = __webpack_public_path__ + "static/media/Group 1341.e0dfbb44.svg";